import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { IServicePeriods } from "./models";
import { servicePeriodItems } from "./service-period.mock";
import { memo, useCallback, useState } from "react";
import { ServicePeriod } from "./ServicePeriodForm/ServicePeriod";

const translationPath = "page.4uDlist.generationRule.servicePeriod.";

export const ServicePeriodPage = memo(() => {
  const [servicePeriod, setServicePeriod] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const columns: GridColDef<IServicePeriods>[] = [
    {
      field: "serviceType",
      headerName: t(translationPath + "service_types") || "Service Type",
      renderCell: ({ row: { serviceType } }) => {
        if (serviceType && serviceType.length > 0) {
          const text = serviceType.join("; ");
          return (
            <OverflowTooltip
              text={text}
              tooltip={text}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "startDate",
      headerName: t(translationPath + "start_date") || "Start Date",
      renderCell: ({ row: { startDate } }) => {
        if (startDate && startDate.length > 0) {
          const date = new Date(startDate);
          return (
            <OverflowTooltip
              text={date.toLocaleDateString("pt-BR")}
              tooltip={date.toLocaleDateString("pt-BR")}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "endDate",
      headerName: t(translationPath + "end_date") || "End Date",
      renderCell: ({ row: { endDate } }) => {
        if (endDate && endDate.length > 0) {
          const date = new Date(endDate);
          return (
            <OverflowTooltip
              text={date.toLocaleDateString("pt-BR")}
              tooltip={date.toLocaleDateString("pt-BR")}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
  ];

  const handleAdd = () => {
    setServicePeriod(true);
  };

  const handleRowClick = (params: GridRowParams<IServicePeriods>) => {
    if (!params.row) return;
    setServicePeriod(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setServicePeriod(false);
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {servicePeriod && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <ServicePeriod id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!servicePeriod && (
        <Box height={600}>
          <Table<IServicePeriods>
            showDefaultMacroFilters={false}
            rows={servicePeriodItems}
            columns={columns}
            title={t(translationPath + "service_periods")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={
              t(translationPath + "add_service_period") || "Add Service Period"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
